import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { HomeProject } from '@models/swagger';
import { PutProjectParams } from './service';

export enum PutProjectActions {
  Failure = '[Project PutProject] Failure',
  Request = '[Project PutProject] Request',
  Success = '[Project PutProject] Success',
  Reset = '[Project PutProject] Reset',
}

export const PutProjectFailure = createAction(PutProjectActions.Failure, props<{ error: HttpErrorResponse }>());

export const PutProjectRequest = createAction(
  PutProjectActions.Request,
  props<{ body: HomeProject; parameters: PutProjectParams }>()
);

export const PutProjectSuccess = createAction(PutProjectActions.Success, props<{ data: HomeProject }>());

export const PutProjectReset = createAction(PutProjectActions.Reset);
